import React, { useState } from "react";
import less from "./policiesInfo.module.scss";

const createCancellationPolicyTable = cancellationPolicy => {
  if (!cancellationPolicy || !cancellationPolicy.length) return "";

  let themeColor = "#D6C1F8";
  let str = `<style>.table{border:1px solid #b2b2b2;border-radius:20px;overflow:hidden;margin-bottom:20px;}.table>div{display:flex;border-bottom:1px solid #b2b2b2;font-weight:500;font-size:15px;line-height:21px;text-align:left;width:100%;align-items:center}.table>div:first-child{background:${themeColor};font-weight:600;font-size:17px}.table>div:last-child{border-bottom:0}.table>div>p{margin:0;padding:15px}.table>div>p:first-child{width:75%;border-right:1px solid #b2b2b2}.table>div>p:nth-child(2){width:25%;word-wrap:break-word;}.table>div>b{text-align:left;width:100%;padding:15px}</style>`;

  str += `<div class="table"><div><p><b>Cancellation Time</b> (Valid from trip start time)</p><p><b>Refund Percentage</b></p></div>`;

  for (let i = 0; i < cancellationPolicy.length; ++i) {
    const { conditions, rule } = cancellationPolicy[i];

    if (
      conditions.maxCancellationAllowed &&
      conditions.maxCancellationAllowed > 0
    ) {
      const noOfDays = conditions.thresholdTime / (24 * 60 * 60 * 1000);
      str += `<div><b>${conditions.maxCancellationAllowed} last-minute free cancellation within the last ${noOfDays} rolling days, if eligible:-</b></div>`;

      for (let j = 0; j < rule.length; ++j) {
        const {
          fromCancellationTime,
          toCancellationTime,
          cancellationPercentage
        } = rule[j];
        let isMinuteRulePresent = false;
        let fromTime = fromCancellationTime / (60 * 60 * 1000);
        if (fromTime > 1) {
          fromTime = `${fromTime} Hours`;
        } else {
          if (fromTime > 0) isMinuteRulePresent = true;
          fromTime = `${fromCancellationTime / (60 * 1000)} Minutes`;
        }
        let toTime = toCancellationTime / (60 * 60 * 1000);
        if ((toTime > 1 || toTime === 0) && !isMinuteRulePresent) {
          toTime = `${toTime} Hours`;
        } else {
          toTime = `${toCancellationTime / (60 * 1000)} Minutes`;
        }
        if (fromCancellationTime === -1) {
          str += `<div><p>More than ${toTime}</p><p>${100 -
            cancellationPercentage}%</p></div>`;
        } else {
          str += `<div><p>${fromTime} to ${toTime}</p><p>${100 -
            cancellationPercentage}%</p></div>`;
        }
      }

      str += `<div><b>After ${conditions.maxCancellationAllowed} last-minute free cancellations the following policy will be applicable:-</b></div>`;
      continue;
    }

    if (
      conditions.maxCancellationAllowed === -1 &&
      conditions.thresholdTime === -1
    ) {
      for (let j = 0; j < rule.length; ++j) {
        const {
          fromCancellationTime,
          toCancellationTime,
          cancellationPercentage
        } = rule[j];
        let isMinuteRulePresent = false;
        let fromTime = fromCancellationTime / (60 * 60 * 1000);
        let toTime = toCancellationTime / (60 * 60 * 1000);
        if (fromTime > 1) {
          fromTime = `${fromTime} Hours`;
        } else {
          if (fromTime > 0) isMinuteRulePresent = true;
          fromTime = `${fromCancellationTime / (60 * 1000)} Minutes`;
        }
        if ((toTime > 1 || toTime === 0) && !isMinuteRulePresent) {
          toTime = `${toTime} Hours`;
        } else {
          toTime = `${toCancellationTime / (60 * 1000)} Minutes`;
        }
        if (fromCancellationTime === -1) {
          str += `<div><p>More than ${toTime}</p><p>${100 -
            cancellationPercentage}%</p></div>`;
        } else {
          str += `<div><p>${fromTime} to ${toTime}</p><p>${100 -
            cancellationPercentage}%</p></div>`;
        }
      }
    }
  }

  str += `</div>`;
  return str;
};

const POLICIES = [
  {
    key: "pet",
    Image:
      "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/pet.svg",
    tabName: "Pet Policy (No pets allowed)",
    title: "PET POLICY - NO PETS ALLOWED",
    sections: [
      {
        points: [
          "zingbus does not permit pets or animals of any kind on board",
          "Exception: Certified service animals accompanying passengers with documented disabilities"
        ],
        subpoints: [
          "Service animals must be properly harnessed/leashed at all times",
          "Must remain under handler's control throughout journey",
          "Documentation must be provided at time of booking",
          "Emotional support animals do not qualify as service animals"
        ],
        extraPoints: [
          "Violation of this policy will result in denied boarding with no refund"
        ]
      }
    ]
  },
  {
    key: "luggage",
    Image:
      "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/luggage.svg",
    tabName: "Luggage Limits and Restrictions",
    title: "Luggage Limits and Restrictions",
    sections: [
      {
        heading: "Standard Baggage Allowance:",
        points: [
          "Maximum baggage allowed per passenger is 15 Kgs, Excess baggage will be charged as per the zingbus rules. zingbus also reserves the right to disallow any excess baggage carried by passengers.",
          "Each passenger is permitted one handbag (cabin bag) and one large luggage item as part of their ticket fare",
          "Cabin baggage must be stored in overhead compartments or under the seat",
          "Large luggage will be stored in the bus luggage compartment"
        ]
      },
      {
        heading: "Extra Luggage Charges:",
        plainText:
          "Extra luggage beyond the standard allowance is chargeable as follows:",
        points: [
          "Extra luggage above 15 kg will be charged Rs 25 per Kg",
          "Extra luggage charges are payable at the time of boarding and are subject to availability of space",
          "Subject to space availability",
          "Zingbus reserves the right to refuse oversized or excessive luggage that compromises safety or comfort of other passengers"
        ]
      }
    ]
  },

  {
    key: "prohibited",
    tabName: "Prohibited Items List",
    Image:
      "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/restricted.svg",
    title: "PROHIBITED ITEMS - ZERO TOLERANCE POLICY",
    sections: [
      {
        plainText:
          "Passengers are strictly prohibited from carrying the following items on Zingbus services:"
      },
      {
        heading: "Category A - Dangerous & Illegal Substances:",
        points: [
          "Alcohol and alcoholic beverages",
          "Narcotics, drugs, and psychotropic substances",
          "Flammable substances and liquids",
          "Weapons of any kind (firearms, knives, sharp objects, etc.)",
          "Gas cylinders and compressed gases",
          "Explosives, fireworks, and incendiary devices",
          "Hazardous chemicals and corrosive materials"
        ]
      },
      {
        heading: "Category B - Organic & Biological Materials:",
        points: [
          "Live animals, birds, or insects of any kind",
          "Fish, endangered species or seafood products",
          "Items with foul, strong, or offensive odor"
        ]
      },

      {
        heading: "Category C - Restricted Forest Products:",
        points: [
          "Animal horns, bones, fur, skin, or ivory",
          "Forest products without proper government license or authorization",
          "Any wildlife products banned under law"
        ]
      },
      {
        heading: "CONSEQUENCES OF VIOLATION:",
        points: [
          "Immediate deboarding without any refund",
          "Confiscation of prohibited items",
          "Legal action and involvement of law enforcement authorities",
          "Permanent ban from Zingbus services",
          "Passenger will be held liable for any damages, penalties, or legal consequences"
        ]
      },
      {
        plainText:
          "Zingbus reserves the right to inspect luggage at any time. Passengers refusing inspection will be denied travel without refund."
      }
    ]
  },

  {
    key: "smoking",
    Image:
      "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/liquor.svg",
    tabName: "Smoking and Alcohol Policy",
    title: "DRUGS, SMOKING OR ALCOHOL CONSUMPTION/INFLUENCE - ZERO TOLERANCE",
    sections: [
      {
        plainText:
          "Zingbus enforces a zero tolerance policy regarding smoking, drugs and alcohol:"
      },
      {
        heading: "Strictly Prohibited:",
        points: [
          "Traveling on zingbus while under the influence of alcohol or drugs",
          "Consuming any alcohol or drugs on board the bus",
          "Smoking of any kind is strictly prohibited on zingbus",
          "Carrying alcohol or drugs in any form (bottles, cans, containers, etc.)"
        ]
      },
      {
        heading: "Enforcement:",
        points: [
          "Passengers appearing intoxicated or impaired will be denied boarding with no refund",
          "Any passenger found consuming or carrying alcohol/drugs will be immediately deboarded",
          "No refund or compensation will be provided in case of violation",
          "Legal action may be initiated as per applicable laws"
        ]
      },
      {
        heading: "Staff Authority:",
        points: [
          "Zingbus staff have full authority to assess passenger condition",
          "Staff decisions regarding intoxication or impairment are final and non-negotiable",
          "Passengers must cooperate with any sobriety assessment if requested"
        ]
      }
    ]
  },

  {
    key: "behavior",
    Image:
      "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/seatPolicy.svg",
    tabName: "Passenger Behavior Code",
    title: "PASSENGER SEATING & BEHAVIOR CODE - MANDATORY COMPLIANCE",
    sections: [
      {
        heading: "Seat Allocation:",
        points: [
          "Passengers must occupy only their designated seats or berths as per their ticket",
          "Unauthorized seat/berth changes are strictly prohibited",
          "Seating arrangements must comply with government regulations regarding gender-based rules."
        ]
      },

      {
        heading: "Prohibited Behavior:",
        plainText:
          "The following behaviors will result in immediate deboarding without refund:",
        points: [
          "Harassment of any kind toward fellow passengers or zingbus staff",
          "Arguing or being disrespectful with staff regarding seating arrangements or company policies",
          "Misuse or tampering with bus fittings, equipment, or property",
          "Abusive language or conduct toward anyone on board",
          "Creating disturbances that affect other passengers or driver safety",
          "Failure to follow instructions from Zingbus crew or driver"
        ]
      },
      {
        heading: "Passenger Conduct Requirements:",
        points: [
          "Maintain courteous and respectful behavior at all times",
          "Keep mobile phones on silent or low volume",
          "Remain seated with seatbelts fastened when bus is in motion",
          "Do not distract or disturb the driver under any circumstances",
          "Dispose of waste properly; keep the bus clean",
          "Respect privacy and personal space of fellow passengers"
        ]
      },
      {
        heading: "Penalties for Misconduct:",
        points: [
          "Immediate deboarding at the nearest safe location",
          "No refund will be provided",
          "Permanent ban from Zingbus services",
          "Legal action where applicable",
          "Passenger will be liable for any damages caused"
        ]
      }
    ]
  },

  {
    key: "refund",
    Image:
      "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/person_cancel.svg",
    tabName: "Refund and Cancellation Terms",
    title: "Refund and Cancellation Terms",
    sections: [
      {
        dynamicTable: true
      },
      {
        points: [
          "If the cancellation is done after the journey time then no refund will be processed.",
          "The said policy is applicable on tickets booked by zingbus.com (web or mobile) and the zingbus app only.",
          "For tickets booked from any other channel or OTA partner, the cancellation policy as mentioned by the channel/OTA partner will be applicable.",
          "Convenience Fee is non-refundable."
        ]
      },
      {
        heading: "Service Cancellation by Zingbus:",
        points: [
          "If Zingbus cancels a service due to operational/technical issues or force:"
        ],
        subpoints: [
          "Passengers will receive a full refund, OR",
          "Option to reschedule at no additional cost"
        ],
        extraPoints: [
          "Refunds processed within 7-10 business days to original payment method"
        ]
      },
      {
        heading: "Rescheduling:",
        points: [
          "Subject to availability and fare difference",
          "Additional charges may apply based on new journey date and seat availability"
        ]
      }
    ]
  },

  {
    key: "child",
    Image:
      "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/child.svg",
    tabName: "Child & Infant Policy",
    title: "TRAVELING WITH MINORS - MANDATORY RULES",
    sections: [
      {
        heading: "Ticketing Requirements:",
        points: [
          "Children aged 5 years and above MUST have a separate valid ticket",
          "Full fare applies to all children 5 years and older"
        ]
      },
      {
        heading: "Infant Travel Policy:",
        points: [
          "One child under 5 years of age may share a berth/seat with an accompanying adult",
          "The child must not occupy a separate seat",
          "Only one infant per adult passenger is allowed under this policy",
          "Additional children under 5 require separate tickets"
        ]
      }
    ]
  },

  {
    key: "bus",
    Image:
      "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/directions_bus.svg",
    tabName: "Bus Information",
    title: "GENERAL TERMS & CONDITIONS",
    sections: [
      {
        heading: "Zingbus Rights & Authority:",
        points: [
          "Zingbus reserves the right to refuse service to any passenger for safety, security, or policy violation reasons",
          "Zingbus may involve law enforcement authorities in cases of serious violations"
        ]
      }
    ]
  }
];

const PoliciesInformation = props => {
  const [activePolicy, setActivePolicy] = useState(null);
  const { cancellationPolicy } = props;

  return (
    <div className={less.wrapper}>
      <p className={less.heading}>Policies and Information</p>
      {/* LIST VIEW */}
      {!activePolicy && (
        <div className={less.list}>
          {POLICIES.map(item => (
            <div
              key={item.key}
              className={less.card}
              // trigger an event on click
              onClick={() => {
                setActivePolicy(item);
                props.setEvents(item.tabName, "POLICY");
              }}
            >
              {/* IMAGE PLACEHOLDER */}
              <img className={less.icon} src={item.Image} alt="Icon" />

              <span className={less.title}>{item.tabName}</span>

              <div className={less.arrow}>{">"}</div>
            </div>
          ))}
        </div>
      )}
      {activePolicy && (
        <div className={less.fullscreen}>
          <div className={less.header}>
            <span onClick={() => setActivePolicy(null)}>← Back</span>
          </div>

          <div className={less.content}>
            <h2 className={less.mainTitle}>{activePolicy.title}</h2>

            {activePolicy.sections.map((section, index) => (
              <div key={index} className={less.section}>
                {/* DYNAMIC CANCELLATION POLICY TABLE */}
                {section.dynamicTable &&
                  cancellationPolicy &&
                  cancellationPolicy.length > 0 && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: createCancellationPolicyTable(
                          cancellationPolicy
                        )
                      }}
                    />
                  )}

                {/* SUB HEADING */}
                {section.heading && (
                  <h3 className={less.subHeading}>{section.heading}</h3>
                )}

                {/* PLAIN TEXT */}
                {section.plainText && (
                  <p className={less.plainText}>{section.plainText}</p>
                )}

                {/* MAIN POINTS */}
                {section.points && (
                  <ul className={less.points}>
                    {section.points.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                )}

                {/* SUB POINTS */}
                {section.subpoints && (
                  <ul className={less.subpoints}>
                    {section.subpoints.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                )}

                {/* EXTRA POINTS */}
                {section.extraPoints && (
                  <ul className={less.points}>
                    {section.extraPoints.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PoliciesInformation;
